//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'src/index';

export default {
  data() {
    return {
      value: null,
      value2: null,
      value3: null,
      value4: null,
      value5: '04:32',
      visible: false,
      visible2: false,
      visible3: false,
      visible4: false,
      visible5: false
    };
  },

  methods: {
    open(picker) {
      this.$refs[picker].open();
    },

    handleChange(value) {
      Toast({
        message: '已选择 ' + value.toString(),
        position: 'bottom'
      });
    }
  }
};



// WEBPACK FOOTER //
// ./example/pages/datetime-picker.vue